import { H3 } from "../../components/headline/Headline";

export default function ContactFormError() {

    return <>
        <H3 text="Fehler bei der Verarbeitung" />
        <div>
            <p>
                Leider ist während der Verarbeitung ein Fehler aufgetreten.<br />
                Bitte lade die Seite erneut und versuche es nochmal oder melde schreib uns eine Nachricht an <a href="mailto:moinmoin@cablesport.de">moinmoin@cablesport.de</a>.
                <br />
                <br />
                Dein CAP Team
            </p>

        </div>
    </>
}  